import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Header from "components/Headers/Header";
import { Formik } from "formik";
import UseFullPageLoader from "utils/UseFullPageLoader";
import { importLightNovel } from "utils/endpoint";

const ImportLightNovel = () => {
  const [loader, showLoader, hideLoader] = UseFullPageLoader();
  const [loading, setLoading] = useState(false);
  const [lightNovelDataFile, setLightNovelDataFile] = useState("");
  const [lightNovelImageFile, setLightNovelImageFile] = useState("");
  const [lightNovelDataFileError, setLightNovelDataFileError] = useState(null);
  const [lightNovelImageFileError, setLightNovelImageFileError] =
    useState(null);
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result.split(",")[1];
        if (event.target.name === "light_novel_data") {
          setLightNovelDataFile(base64);
        } else {
          setLightNovelImageFile(base64);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSampleCsvFileDownload = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/sample-files/light-novel-sample-data.csv`;
    link.download = "light-novel-sample-data.csv";
    link.click();
  };

  const handleSampleImageZipFileDownload = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/sample-files/light-novel-sample-images.zip`;
    link.download = "light-novel-sample-images.zip";
    link.click();
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        light_novel_data: null,
        light_novel_images: null,
      }}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        if (!values.light_novel_data) {
          setLightNovelDataFileError("Data file is required");
        }
        if (!values.light_novel_images) {
          setLightNovelImageFileError("Image file is required");
        }
        if (!(values.light_novel_data && values.light_novel_images)) {
          return false;
        }
        setLoading(true);
        showLoader();

        const finalObj = {
          light_novel_data: lightNovelDataFile,
          light_novel_images: lightNovelImageFile,
        };
        const result = await importLightNovel(finalObj);
        if (result?.isSuccess) {
          toast.success("Light novel imported successfully!");
          setLoading(false);
          hideLoader();
          resetForm();
          navigate("/admin/lightNovel/light-Novel-list");
        } else {
          setSubmitting(false);
          setLoading(false);
          hideLoader();
          return toast.error(
            result.message || `Something went wrong, please try again letter!`
          );
        }
      }}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <form onSubmit={handleSubmit} autoComplete="off">
          <>
            <Header />

            <Container className="mt--7" fluid>
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <Row>
                        <Col lg="6">
                          <h1 className="mb-0">Import Light Novel</h1>
                        </Col>
                        <Col lg="6" className="add_btn text-right">
                          <Button
                            color="primary"
                            className=""
                            onClick={() => {
                              navigate("/admin/lightNovel/light-Novel-list");
                            }}
                          >
                            <span className="me-2">Back</span>
                          </Button>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <div className="d-flex mb-1">
                              <label className="form-control-label required">
                                Light Novel Data (*.CSV)
                              </label>
                              <Button
                                className="btn-sm ml-auto"
                                color="primary"
                                title="Download sample csv file of light novel"
                                onClick={async () => {
                                  handleSampleCsvFileDownload();
                                }}
                              >
                                <i class="fa fa-download"></i>
                              </Button>
                            </div>
                            <div className="form-control w-100 m-0 ">
                              <label
                                className="mb-0 text-muted"
                                style={{ cursor: "pointer" }}
                              >
                                {values?.light_novel_data
                                  ? values?.light_novel_data
                                  : "Click here to upload csv file"}
                                <i
                                  className="fa fa-upload ml-2"
                                  aria-hidden="true"
                                ></i>
                                <Input
                                  id="light_novel_data"
                                  type="file"
                                  accept=".csv"
                                  name="light_novel_data"
                                  className="form-control d-none"
                                  onChange={(event) => {
                                    if (event?.target?.files[0]?.name) {
                                      setFieldValue(
                                        "light_novel_data",
                                        event?.target?.files[0]?.name || null
                                      );
                                      setLightNovelDataFileError(null);
                                    }
                                    handleFileChange(event);
                                  }}
                                />
                              </label>
                            </div>
                            {lightNovelDataFileError && (
                              <div className="text-danger text-align-top-center mt-1">
                                {lightNovelDataFileError}
                              </div>
                            )}
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <div className="d-flex mb-1">
                              <label className="form-control-label required">
                                Images (*.Zip)
                              </label>
                              <Button
                                className="btn-sm ml-auto"
                                color="primary"
                                title="Download sample images zip file of light novel"
                                onClick={async () => {
                                  handleSampleImageZipFileDownload();
                                }}
                              >
                                <i class="fa fa-download"></i>
                              </Button>
                            </div>
                            <div className="form-control w-100 m-0 ">
                              <label
                                className="mb-0 text-muted"
                                style={{ cursor: "pointer" }}
                              >
                                {values?.light_novel_images
                                  ? values?.light_novel_images
                                  : "Click here to upload images"}
                                <i
                                  className="fa fa-upload ml-2"
                                  aria-hidden="true"
                                ></i>
                                <Input
                                  id="light_novel_images"
                                  type="file"
                                  accept=".zip"
                                  name="light_novel_images"
                                  className="form-control d-none"
                                  onChange={(event) => {
                                    if (event?.target?.files[0]?.name) {
                                      setFieldValue(
                                        "light_novel_images",
                                        event?.target?.files[0]?.name || null
                                      );
                                      setLightNovelImageFileError(null);
                                    }
                                    handleFileChange(event);
                                  }}
                                />
                              </label>
                            </div>
                            {lightNovelImageFileError && (
                              <div className="text-danger text-align-top-center mt-1">
                                {lightNovelImageFileError}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="3">
                          <Button
                            type="submit"
                            className="my-3 w-100"
                            color="primary"
                          >
                            {loading && (
                              <span
                                className="indicator-progress"
                                style={{ display: "block" }}
                              >
                                Please Wait..
                                <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                              </span>
                            )}
                            {!loading && (
                              <span className="indicator-label">Import</span>
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              </Row>
            </Container>
            {loader}
          </>
        </form>
      )}
    </Formik>
  );
};

export default ImportLightNovel;
